/*global angular */
/*jslint node: true */

'use strict';

var renderGroups = angular.module('renderGroups', []);
renderGroups.directive('renderGroups', ['$templateCache', function ($templateCache) {
    return {
        restrict: 'A',
        template: $templateCache.get('groups/render/renderGroups.html'),
        link: function (scope, el, attrs) {
        }
    };
}]);
